import IntentAddDialog from "./intent-add-dialog.vue";
import IIntentAddDialog from "./intent-add-dialog";
import { ValidationRule } from "ant-design-vue/types/form/form";
import { IntentLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import { getModule } from "vuex-module-decorators";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import { CLUValidations } from "@/util/constants";

export { IntentAddDialog, IIntentAddDialog };

export const invalidIntentNameRegex: RegExp = /[:$&%*()+~#/\\?]/;

export function intentNameValidator(rule: ValidationRule, value: string, callback: (value?: string) => void) {
	const isInvalid = invalidIntentNameRegex.test(value);

	if (isInvalid) {
		callback(fmtMsg(IntentLocale.IntentNameInvalidCharMsg));
	} else {
		callback();
	}
}

export function intentNameLengthValidator(rule: ValidationRule, value: string, callback: (value?: string) => void) {
	const isInvalid = value && value.length > CLUValidations.intentNameLengthLimit ? true : false;

	if (isInvalid) {
		callback(fmtMsg(IntentLocale.IntentNameLengthLimitMsg));
	} else {
		callback();
	}
}

export function intentUniqueValidator(currentIntentName?: string) {
	const conversationStore = getModule(ConversationBuilderState);
	return (rule: ValidationRule, value: string, callback: (value?: string) => void) => {
		let transformedValue = value;

		if (transformedValue) {
			transformedValue = value.trim().toLowerCase();
		}

		const existingIntent = conversationStore.intents.ids.find(
			(id) => conversationStore.intents.directory[id].name.trim().toLowerCase() === transformedValue
		);

		const existingEntities = conversationStore.entities.ids.find(
			(id) => conversationStore.entities.directory[id].name.trim().toLowerCase() === transformedValue
		);

		if (existingIntent || existingEntities) {
			callback(fmtMsg(IntentLocale.IntentNameUniqueMsg));
		} else {
			callback();
		}
	};
}
export function intentManageValidator(currentIntentId?: string) {
	const conversationStore = getModule(ConversationBuilderState);
	return (rule: ValidationRule, value: string, callback: (value?: string) => void) => {
		let transformedValue = value;

		if (transformedValue) {
			transformedValue = value.trim().toLowerCase();
		}

		const existingIntent = conversationStore.intents.ids.find(
			(id) => id !== currentIntentId && conversationStore.intents.directory[id].name.trim().toLowerCase() === transformedValue
		);

		const existingEntities = conversationStore.entities.ids.find(
			(id) => conversationStore.entities.directory[id].name.trim().toLowerCase() === transformedValue
		);

		if (existingIntent || existingEntities) {
			callback(fmtMsg(IntentLocale.IntentNameUniqueMsg));
		} else {
			callback();
		}
	};
}